var $72a29a66fe741789$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    var e = document.createElement("link");
    e.rel = "manifest", e.href = "manifest.json", document.head.appendChild(e);
});


//# sourceMappingURL=index.20d80c73.js.map
